import { Card } from "../ui/card";
import { ColumnState } from "./DataTable";

interface MobileCardProps<T> {
  id: string;
  item: T;
  columns: (ColumnState<T> & { accessor: (item: T) => React.ReactNode })[];
  onRowClick?: (row: T) => void;
  renderSelectionColumn?: (item: T) => React.ReactNode;
}

export function MobileCard<T>(props: Readonly<MobileCardProps<T>>) {
  const { id, item, columns, onRowClick, renderSelectionColumn } = props;

  // 1. Separamos as colunas 'headless' (Ações) das colunas de dados normais
  const headlessCols = columns.filter((c) => c.type === "headless");
  const dataCols = columns.filter((c) => c.type !== "headless");

  // 2. Separamos a primeira coluna de dados para ser o "Título" do card
  const [firstCol, ...otherCols] = dataCols;

  return (
    <Card
      key={id}
      className="relative border-l-4 border-l-primary p-4 shadow-sm transition-all hover:shadow-md active:scale-[0.98]"
      onClick={() => onRowClick?.(item)}
    >
      {/* 3. Container de Ações e Seleção (Absoluto no topo direito) */}
      <div
        className="absolute right-2 top-2 z-10 flex items-center gap-1"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Renderiza as colunas headless (Menu de Ações) */}
        {headlessCols.map((col) => (
          <div key={col.key}>{col.accessor(item)}</div>
        ))}

        {/* Renderiza o Checkbox de seleção, se existir */}
        {renderSelectionColumn && <div>{renderSelectionColumn(item)}</div>}
      </div>

      <div className="flex flex-col gap-4">
        {/* Cabeçalho do Card */}
        {/* Aumentei o padding-right (pr-16) para o texto não encavalar nos botões */}
        <div className="pr-16">
          <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
            {firstCol?.title}
          </span>
          <h3 className="mt-0.5 text-base font-semibold leading-tight text-foreground">
            {firstCol?.accessor(item) ?? "-"}
          </h3>
        </div>

        {/* Grid de Informações Secundárias */}
        <div className="grid grid-cols-2 gap-x-4 gap-y-3 border-t border-dashed border-border pt-3">
          {otherCols.map((col) => (
            <InfoRow key={col.key} label={col.title} value={col.accessor(item)} />
          ))}
        </div>
      </div>
    </Card>
  );
}

function InfoRow({ label, value }: { label: string; value: React.ReactNode }) {
  if (!value || value === "-") return null;

  return (
    <div className="flex min-w-0 flex-col">
      <span className="truncate text-[10px] font-semibold uppercase tracking-wider text-muted-foreground/70">
        {label}
      </span>
      <div className="scrollbar-none mt-0.5 overflow-x-auto pb-1 text-sm font-medium text-foreground/90">
        {value}
      </div>
    </div>
  );
}
